//import packages from node modules
import PropTypes from "prop-types"
import {withRouter} from "react-router-dom"
import React from "react"

//import shared components
import SearchDomainResultItem from "./SearchDomainResultItem"
import Loading from "../loading"

let SearchDomainResult = (props) => {
    //define variables
    const {
        requestGetDomainSuggestions,
        requestCheckDomain,
        searchItemCallback,
        isNewDomainName,
        isTransferMode
    } = props

    //define functions
    const selectedDomainResult = () => {
        const {status, data} = requestCheckDomain
        if (status === 'success' && data) {
            return (<div className={'of-search-domain-result of-search-domain-result--selected'}>
                {renderItemList(data, true)}

            </div>)
        }else{
            if(status==='loading'){
                return (<>{renderLoading()}</>)
            }
        }
        return (<></>)
    }
    const domainResultSuggestions = () => {
        const {status, data} = requestGetDomainSuggestions
        const renderSuggestionLoading = () => {
            if (status === 'loading') {
                return (
                    <div className={'of-search-suggestion-result__loading-wrapper'}>
                        <Loading/>
                    </div>
                )
            }
        }
        return (<div className={'of-search-domain-result of-search-suggestion-result'}>
            {data && isNewDomainName && requestCheckDomain.status === "success" ? renderItemList(data) : <></>}
            {renderSuggestionLoading()}
        </div>)
    }

    //define render functions
    const renderItemList = (data, selected = false) => {
        if (data && data.length > 0) {
            return data.map((item, index) => {
                return (<SearchDomainResultItem isTransferMode={isTransferMode} key={index} item={item} selected={selected}
                                                searchItemCallback={searchItemCallback}/>)
            })
        }
        return (<></>)
    }
    const renderLoading = () => {
        return (<div className={'of-search-domain-result of-search-domain-result--loading'}>
            <Loading/>
        </div>)
    }

    return (<div className={'of-search-domain-result'}>
        <div className={'of-search-domain-result__wrapper clearfix'}>
            {selectedDomainResult()}
            {domainResultSuggestions()}
        </div>
    </div>)
}

SearchDomainResult.propTypes = {
    requestGetDomainSuggestions: PropTypes.object,
    requestCheckDomain: PropTypes.object,
    searchItemCallback: PropTypes.func,
    location: PropTypes.any,
    isNewDomainName: PropTypes.bool,
    isTransferMode: PropTypes.bool
}

SearchDomainResult = withRouter(SearchDomainResult)

export default SearchDomainResult